module.exports = __webpack_public_path__ + "img/icon-level-3.f18b0462.png";